import React from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";

import { messages } from "./messages";

export interface LegalNoticeProps {
    onClick?: (e: React.MouseEvent) => void;
    productName: string;
}

const termsTextStyle = css({
    fontFamily: wacToken("font.charlie.text"),
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px",
    color: token("color.text.subtlest"),
    margin: 0,
    [media.above.md]: {
        fontSize: "14px",
        lineHeight: "16px"
    }
});

const termsLinkStyle = css({
    "color": token("color.link"),
    "textDecoration": "none",
    "&:hover": {
        textDecoration: "underline"
    }
});

export const TemplateLegalNotice: React.FC<LegalNoticeProps> = ({
    onClick,
    productName
}) => {
    return (
        <p css={termsTextStyle}>
            <FormattedMessage
                {...messages.legalNotice}
                values={{
                    customerAgreementLink: (
                        <a
                            href="https://www.atlassian.com/legal/customer-agreement"
                            target="_blank"
                            rel="noopener noreferrer"
                            css={termsLinkStyle}
                            onClick={onClick}
                        >
                            <FormattedMessage
                                {...messages.customerAgreementLinkText}
                            />
                        </a>
                    ),
                    privacyPolicyLink: (
                        <a
                            href="https://www.atlassian.com/legal/privacy-policy"
                            target="_blank"
                            rel="noopener noreferrer"
                            css={termsLinkStyle}
                            onClick={onClick}
                        >
                            <FormattedMessage
                                {...messages.privacyPolicyLinkText}
                            />
                        </a>
                    )
                }}
            />{" "}
            <FormattedMessage
                {...messages.additionalInfo}
                values={{ productName }}
            />
        </p>
    );
};
